import React from 'react'

export default () => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="12.000000pt" height="12.000000pt" viewBox="0 0 72.000000 72.000000"
    preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,72.000000) scale(0.100000,-0.100000)"
      fill="#cccccc" stroke="none">
      <path d="M200 707 c-19 -6 -51 -28 -71 -48 -79 -79 -60 -205 48 -320 50 -53
130 -109 157 -109 52 0 204 150 230 226 40 119 2 212 -103 249 -51 18 -207 19
-261 2z m243 -39 c21 -6 51 -27 67 -45 59 -66 28 -175 -76 -274 -88 -83 -96
-86 -147 -50 -52 35 -119 107 -142 150 -27 53 -30 121 -6 158 46 73 175 99
304 61z"/>
      <path d="M243 630 c-23 -13 -42 -18 -63 -14 -29 6 -30 6 -30 -35 0 -39 25 -81
49 -81 5 0 11 -12 14 -28 3 -15 15 -53 27 -85 19 -50 26 -58 59 -68 30 -9 44
-8 73 4 33 14 38 22 59 89 13 41 32 82 45 93 29 25 44 66 37 95 -5 18 -11 21
-35 16 -19 -4 -39 1 -61 14 -21 14 -50 20 -87 20 -37 0 -66 -6 -87 -20z"/>
      <path d="M73 325 c-35 -15 -43 -32 -44 -95 0 -25 -1 -60 -1 -78 -1 -19 7 -44
20 -62 12 -16 22 -43 22 -60 0 -23 4 -30 19 -30 12 0 21 8 24 22 l4 23 2 -22
c1 -30 41 -33 41 -3 0 25 15 25 47 0 32 -25 85 -26 106 -2 16 17 12 22 -58 92
-41 41 -75 78 -75 82 0 5 9 8 20 8 16 0 20 7 20 36 0 50 -13 69 -60 88 -48 19
-46 19 -87 1z"/>
      <path d="M425 256 c-28 -37 -32 -77 -10 -96 10 -8 15 -30 15 -62 0 -39 5 -54
25 -73 21 -22 33 -25 100 -25 42 0 85 5 97 11 26 14 50 73 42 104 -4 18 -1 27
10 31 24 9 20 65 -7 105 l-23 34 -112 2 -112 2 -25 -33z m190 -26 c10 -11 21
-36 25 -57 4 -21 10 -50 14 -64 8 -29 -15 -63 -51 -74 -28 -8 -32 19 -7 46 22
25 9 39 -36 39 -45 0 -55 -10 -35 -36 8 -10 15 -27 15 -37 0 -14 -5 -17 -22
-11 -42 12 -50 25 -44 68 3 23 8 57 11 76 2 19 14 43 26 53 29 23 81 22 104
-3z"/>
    </g>
  </svg>
)
